import { LOCAL_STORAGE } from 'constants/general';
import { PARAMS } from 'constants/params';
import { getLocalStorage, removeLocalStorage, updateLocalStorage } from 'utils/helpers/storage';
import { getQueryParam } from 'utils/routes.util';

const removeJoinCodeFromUrl = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete(PARAMS.JOIN_CODE);
  url.searchParams.delete(PARAMS.TEAM_ID);
  window.history.replaceState({}, '', url.toString());
};

export const captureJoinCodeFromUrl = (): void => {
  const joinCode = getQueryParam(PARAMS.JOIN_CODE)?.trim();

  if (joinCode) {
    updateLocalStorage(LOCAL_STORAGE.JOIN_CODE, joinCode);
    removeJoinCodeFromUrl();
    return;
  }

  const legacyTeamId = getQueryParam(PARAMS.TEAM_ID)?.trim();
  if (legacyTeamId) {
    updateLocalStorage(LOCAL_STORAGE.JOIN_CODE, legacyTeamId);
    removeJoinCodeFromUrl();
  }
};

export const getStoredJoinCode = (): string | null => {
  return getLocalStorage(LOCAL_STORAGE.JOIN_CODE);
};

export const clearStoredJoinCode = (): void => {
  removeLocalStorage([LOCAL_STORAGE.JOIN_CODE, LOCAL_STORAGE.TEAM_ID_TO_JOIN]);
};
